import { render, staticRenderFns } from "./PCGovernanceItemBigger.vue?vue&type=template&id=6c6e28ae&scoped=true"
import script from "./PCGovernanceItemBigger.vue?vue&type=script&setup=true&lang=js"
export * from "./PCGovernanceItemBigger.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCGovernanceItemBigger.vue?vue&type=style&index=0&id=6c6e28ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e28ae",
  null
  
)

export default component.exports